import { Registration } from '../../types/AssessmentTable.type';
import AssessmentStudentTable from './AssessmentStudentTable';

type Props = {
  handleOpenLevelModal: (
    subsubtypeId: number,
    registration: Registration,
  ) => void;
  refreshKey: number;
};

const FFTable = ({ handleOpenLevelModal, refreshKey }: Props) => (
  <AssessmentStudentTable
    program="FLYING FISH"
    refreshKey={refreshKey}
    handleOpenLevelModal={handleOpenLevelModal}
  />
);

export default FFTable;
